import { BottomSheetModalMethods } from '@gorhom/bottom-sheet/lib/typescript/types'
import React, { RefObject, useCallback, useMemo } from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { CloseButton } from 'widgets/CloseButton'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'

import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'

import { ThemeColor } from 'utils/themes/types'

import { Text } from '../Text'

const styles = StyleSheet.create({
  sideButtonsContainer: {
    width: '25%',
  },
  middleContainer: {
    width: '50%',
  },
})

type BottomSheetNavProps = {
  withBack?: boolean
  onBackPress?: () => void
  withClose?: boolean
  withNext?: boolean
  onNextPress?: () => void
  withDone?: boolean
  rightButtonTitle?: string
  rightButtonColor?: ThemeColor
  backgroundColor?: ThemeColor
  bottomSheetRef?: RefObject<BottomSheetModalMethods> | null
}

export const BottomSheetNav = ({
  withBack = false,
  onBackPress,
  withClose = false,
  withNext = false,
  onNextPress = () => {},
  withDone = false,
  rightButtonColor,
  rightButtonTitle,
  backgroundColor = 'v2primary',
  bottomSheetRef,
}: BottomSheetNavProps) => {
  const navigateBackOrHome = useNavigateBackOrHome()

  const handleCloseBottomSheetPress = useCallback(() => {
    if (bottomSheetRef) {
      bottomSheetRef.current?.dismiss()
    }
  }, [bottomSheetRef])

  const iconButtonColor = useMemo(
    () => (backgroundColor === 'v2primary' ? 'white' : 'black'),
    [backgroundColor],
  )

  const handleBack = () => {
    if (onBackPress) {
      onBackPress()
      return
    }
    navigateBackOrHome()
  }

  return (
    <Box
      testID='BottomSheetNav'
      backgroundColor={backgroundColor}
      flexDirection='row'
      align='center'
      margin='xs'
      justifyContent='center'
    >
      <Box
        testID='LeftButtonsContainer'
        flexDirection='column'
        align='flex-start'
        style={styles.sideButtonsContainer}
      >
        {withBack && (
          <Box
            width={36}
            height={36}
            margin={{ right: 'xs' }}
            justifyContent='center'
            align='center'
            testID='BackButtonContainer'
          >
            <Pressable onPress={handleBack} testID='BackButton'>
              <Icon name='arrow-left' color={iconButtonColor} size={24} />
            </Pressable>
          </Box>
        )}
      </Box>
      <Box
        testID='TitleContainer'
        style={styles.middleContainer}
        flexDirection='column'
        align='center'
      />
      <Box
        testID='RightButtonsContainer'
        flexDirection='column'
        align='flex-end'
        style={styles.sideButtonsContainer}
      >
        <Box flexDirection='row' testID='RightButtonsRow'>
          {withClose && (
            <CloseButton color={iconButtonColor} onPress={handleCloseBottomSheetPress} />
          )}
          {withNext && (
            <Pressable onPress={onNextPress}>
              <Text color={rightButtonColor ?? iconButtonColor}>{rightButtonTitle ?? 'Skip'}</Text>
            </Pressable>
          )}
          {withDone && (
            <Pressable onPress={handleCloseBottomSheetPress}>
              <Text color={rightButtonColor ?? iconButtonColor}>{rightButtonTitle ?? 'Done'}</Text>
            </Pressable>
          )}
        </Box>
      </Box>
    </Box>
  )
}
